import {Component, Input, OnInit} from '@angular/core';
import { CountryGuideService } from 'src/app/shared/services/countryGuide.service';
import { MatSnackBar, MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition } from '@angular/material/snack-bar';
import { CountryGuideDetailComponent } from '../country-guide-detail/country-guide-detail.component';
import { DownloadService } from "src/app/shared/services/download.service";
@Component({
  selector: 'app-country-guide',
  templateUrl: './country-guide.component.html',
  styleUrls: ['./country-guide.component.scss']
})
export class CountryGuideComponent implements OnInit {

  @Input() countryGuide: any;
  showMore: boolean;
  last: any;
  isLoading = false;
  countryId = null;
  regionId = null;
  RegionName=null;
  fileName = null;
  selectedCategoryNav = 0;
    isFirstTime = true;
    Hposition: MatSnackBarHorizontalPosition = 'right';
    VPosition: MatSnackBarVerticalPosition = 'top';

  
    constructor(private countryGuideService: CountryGuideService, private toast: MatSnackBar, private countryGuideDetailParent: CountryGuideDetailComponent, private downloadService: DownloadService,) {
       
  }


  ngOnInit(): void {
     
  }
  onTabChanged($event): void {   
    if (this.countryGuide) {
      this.countryId = this.countryGuide.Country.ID;
      this.regionId = this.countryGuide.Region.ID;
      this.fileName = this.countryGuide.Country.Name;
  }           
    }

    showConfirmationToast(text) {
        this.toast.open(text, 'Got it', {
            duration: 3000, horizontalPosition: this.Hposition,
            verticalPosition: this.VPosition,
            panelClass: 'iwg-toast-text-white',
        });
    }
    downloadPDF(downloadTabId, displayText) {          
    this.countryGuideDetailParent.isLoading = true;
    this.showConfirmationToast('MyGuides PDF is being generated.');    
    if (!this.fileName && this.isFirstTime === true)
    {
        this.setValue();
        this.isFirstTime = false;
    }
    this.RegionName = this.countryGuide.Region.Name;
    if (!this.fileName && this.countryGuide.Country.ID) {
      this.countryGuideService.getCountryGuide({ id: this.countryGuide.Country.ID, regionid: 'null' })
          .subscribe(countryGuide => {          
            this.countryId = countryGuide.data.Data.Country.ID;
            this.regionId = countryGuide.data.Data.Region.ID;
            this.fileName = countryGuide.data.Data.Country.Name;           
            var downloadFileName = 'MyGuides - ' + this.fileName + (this.RegionName != null && this.RegionName != '' && downloadTabId != 4 ? ' - ' + this.RegionName : '') + ' - ' + displayText;     
            var origin = window.location.origin;
            var downloadURL = origin + '/GlobalGuideContents/GlobalGuideClientView?countryId=' + this.countryId + '&regionId=' + this.regionId + '&downloadTabId=' + downloadTabId + '&Pdf=1&filename=' + downloadFileName;
            this.downloadService.saveAs(downloadURL,).then(res => {
                this.countryGuideDetailParent.isLoading = false;
            });;   
        });
    }
        if (this.fileName) {
            var downloadFileName = 'MyGuides - ' + this.fileName + (this.RegionName != null && this.RegionName != '' && downloadTabId != 4 ? ' - ' + this.RegionName : '') + ' - ' + displayText;
            var origin = window.location.origin;
            var downloadURL = origin + '/GlobalGuideContents/GlobalGuideClientView?countryId=' + this.countryId + '&regionId=' + this.regionId + '&downloadTabId=' + downloadTabId + '&Pdf=1&filename=' + downloadFileName;
            this.downloadService.saveAs(downloadURL).then(res => {
                this.countryGuideDetailParent.isLoading = false;
            });;           
        }      
    };

 setValue() {
  if (this.countryGuide) {
      this.countryId = this.countryGuide.Country.ID;
      this.regionId = this.countryGuide.Region.ID;
      this.fileName = this.countryGuide.Country.Name;
  }
}
}
